import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Loader from "../components/Loader";

export default function Users({ onSelect, onAdd, onEdit }) {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEmployees();
  }, []);

  const loadEmployees = async () => {
    const snap = await getDocs(collection(db, "users"));
    const list = snap.docs.map((doc, i) => ({
      id: doc.id,
      sno: i + 1,
      ...doc.data(),
    }));
    setEmployees(list);
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="mt-3 px-4">
      <div className="d-flex justify-content-between mb-3">
        <h5>👥 Users List</h5>
        <button className="btn btn-primary btn-sm" onClick={() => onAdd?.()}>
          ➕ Add User
        </button>
      </div>

      <table className="table table-bordered table-hover">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>UID</th>
            <th>Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Role</th>
            <th width="120">Action</th>
          </tr>
        </thead>

        <tbody>
          {employees.map(emp => (
            <tr key={emp.id}>
              <td>{emp.sno}</td>
              <td>{emp.uid}</td>

              <td>{emp.name}</td>
              <td>{emp.mobile}</td>
              <td>{emp.email}</td>
              <td>{emp.role}</td>

              <td>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => onEdit?.(emp)}
                >
                  ✏ Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
